export class FileGroup {
    externalName: string;
    children: Array<FileGroupChild>;

    constructor(value?: Partial<FileGroup>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class FileGroupChild {
    name: string;
    parent: FileGroup;

    constructor(value?: Partial<FileGroupChild>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}
